<div class="template-deatils">
    <mat-card class="template {{templateType + 'raw' + index}}"
        [ngClass]="{'whats-app-bg': templateType === 'whatsapp'}" *ngIf="!showPreviewOnly">
        <div class="template-header">{{cardHeading.title}}</div>
        <div class="template-body" [ngClass]="{'whats-app-message-box sb14': templateType === 'whatsapp'}">
            <div class="customer-logo-section" *ngIf="logo && templateType === 'email'">
                <img class="logo-img" [src]="logo" width="75px" />
                <img src="../../../../assets/EmailImg.png" class="email-icon">
            </div>
            <div class="subject-line" *ngIf="templateType === 'email' && templateDetails?.subject">
                <span class="subject-label">Subject: </span>
                <span class="subject-text">{{ templateDetails.subject }}</span>
            </div>
            <div *ngIf="templateType === 'whatsapp'" class="whats-app-img">
                <img *ngIf="hasWhatsAppLogo()" [src]="logo" />
            </div>
            <!-- <div [innerHTML]="templateDetails.content" class="content"></div> -->
            <angular-editor [(ngModel)]="templateDetails.content" class="content template-content" id="contentPreview"
                [config]="config"></angular-editor>

            <ng-container *ngIf="templateType === 'whatsapp'">
                <div class="time">{{ dateObj | date:'shortTime' }}</div>
                <div class="btn-section"> <span class="material-icons">open_in_new</span> View Assessment</div>
            </ng-container>
        </div>
    </mat-card>

    <mat-card class="template-preview {{templateType + 'preview' + index}}"
        [ngClass]="{'whats-app-bg': templateType === 'whatsapp'}">
        <div class="template-header">{{showPreviewOnly ? cardHeading.title : cardHeading.previewTitle}}</div>
        <div class="template-body" [ngClass]="{'whats-app-message-box sb14': templateType === 'whatsapp'}">
            <div class="customer-logo-section" *ngIf="logo && templateType === 'email'">
                <img class="logo-img" [src]="logo" width="75" />
                <img src="assets/EmailImg.png" class="email-icon">
            </div>
            <div class="subject-line" *ngIf="templateType === 'email' && templateDetails?.subject">
                <span class="subject-label">Subject: </span>
                <span class="subject-text"
                    [innerHTML]="templateDetails.subject | replaceAll : placeholderDummies"></span>
            </div>
            <div *ngIf="templateType === 'whatsapp'" class="whats-app-img">
                <img *ngIf="hasWhatsAppLogo()" [src]="logo" />
            </div>
            <div class="content">
                <angular-editor [ngModel]="templateDetails.content | replaceAll : placeholderDummies"
                    class="content template-content" id="content" [config]="config"></angular-editor>
            </div>
            <ng-container *ngIf="templateType === 'whatsapp'">
                <div class="time">{{ dateObj | date:'shortTime' }}</div>
                <div class="btn-section"> <span class="material-icons">open_in_new</span> View Assessment</div>
            </ng-container>
        </div>
    </mat-card>
</div>